import { Resolution } from 'src/constants/editor/resolution'

export const COMPRESSOR_PIXELS = {
  [Resolution.SD]: 2_000_000,
  [Resolution.HD]: 12_000_000,
}
